<div class="container-sm px-alt-3 pb-5 main-container">
    <label class="mb-1">{{ 'settings.fontSizeLabel' | translate }}</label>
    <div class="form-col">
        <label class="mb-1">{{ 'settings.reservationList' | translate }}</label>
        <app-dropdown [model]="editingAppSettings.fontSize.reservationList"
            (modelChange)="setFontSize('reservationList', $event)" [items]="fontSizeOptions"
            [displayProperty]="'display'" [valueProperty]="'value'">
        </app-dropdown>
    </div>
    <div class="form-col">
        <label class="mb-1">{{ 'settings.reservationForm' | translate }}</label>
        <app-dropdown [model]="editingAppSettings.fontSize.reservationForm"
            (modelChange)="setFontSize('reservationForm', $event)" [items]="fontSizeOptions"
            [displayProperty]="'display'" [valueProperty]="'value'">
        </app-dropdown>
    </div>
    <div class="form-col">
        <label class="mb-1">{{ 'settings.tablesPlan' | translate }}</label>
        <app-dropdown [model]="editingAppSettings.fontSize.tablesPlan" (modelChange)="setFontSize('tablesPlan', $event)"
            [items]="fontSizeOptions" [displayProperty]="'display'" [valueProperty]="'value'">
        </app-dropdown>
    </div>
</div>